import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import {useDispatch, useSelector} from "react-redux";
import {iFullStoreState} from "../../../shared/interfaces";
import {Actions as GmapActions} from "../../../stores/reducers/gmap-reducers";
import {ReactComponent as FaTimesSolid} from '../../../assets/svg/times-solid.svg'

import './styles.scss';

const BUTTON_OFFSET = {
  TOP: 65,
  RIGHT: 45
};

export const CloseButtonStreetView = () => {
    const dispatch = useDispatch();
    const isStreetView = useSelector<iFullStoreState, boolean>(s => !!s.gmap.streetViewLocation);
    const onClose = () => dispatch(GmapActions.TOGGLE_STREET_VIEW());
    const [buttonStyle, setButtonStyle] = useState<React.CSSProperties>({});

    useEffect(() => {
        const updateButtonPosition = () => {
            const streetViewContainer = document.getElementById('pano');
            if (streetViewContainer && isStreetView) {
                const rect = streetViewContainer.getBoundingClientRect();
                setButtonStyle({
                    position: 'fixed',
                    top: `${rect.top + BUTTON_OFFSET.TOP}px`,
                    left: `${rect.right - BUTTON_OFFSET.RIGHT}px`,
                    zIndex: 50
                });
            }
        };

        // Initial positioning
        updateButtonPosition();

        // Listen for window resize events
        window.addEventListener('resize', updateButtonPosition);

        // Use ResizeObserver to monitor changes in the container's size
        const resizeObserver = new ResizeObserver(updateButtonPosition);
        const streetViewContainer = document.getElementById('pano');
        if (streetViewContainer) {
            resizeObserver.observe(streetViewContainer);
        }

        return () => {
            window.removeEventListener('resize', updateButtonPosition);
            resizeObserver.disconnect();
        };
    }, [isStreetView]);

    return ReactDOM.createPortal(
        <div className={`street-view-close-container ${isStreetView ? 'visible' : 'hidden'}`} style={buttonStyle}>
            <span className="close-button" onClick={onClose}>
                <FaTimesSolid className="icon" />
            </span>
        </div>,
        document.body
    );
};